import * as React from 'react';
export const circlebackSvg = React.forwardRef(function circlebackSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.801 24.998c-1.248 0-2.41-.226-3.488-.679a8.57 8.57 0 0 1-2.785-1.896 8.893 8.893 0 0 1-1.873-2.855C5.218 18.475 5 17.282 5 15.986c0-1.295.218-2.489.655-3.58a8.28 8.28 0 0 1 1.85-2.857 8.27 8.27 0 0 1 2.785-1.872c1.077-.453 2.247-.679 3.511-.679 1.264 0 2.395.21 3.394.632 1.014.421 1.873.983 2.575 1.685.702.703 1.201 1.483 1.498 2.341l-3.207 1.545a4.299 4.299 0 0 0-1.568-2.083c-.734-.562-1.63-.843-2.692-.843-1.03 0-1.935.242-2.715.726a4.96 4.96 0 0 0-1.826 2.013c-.421.842-.632 1.833-.632 2.972 0 1.14.21 2.138.632 2.997a4.96 4.96 0 0 0 1.826 2.012c.78.484 1.685.726 2.715.726 1.061 0 1.958-.273 2.692-.82.749-.56 1.272-1.263 1.568-2.106l3.207 1.545c-.297.858-.796 1.639-1.498 2.34-.702.703-1.56 1.265-2.575 1.686-.999.421-2.13.632-3.394.632Z',
      fill: '#F24E1D',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.634 24.9a1.646 1.646 0 1 0 0-3.292 1.646 1.646 0 0 0 0 3.292Z',
      fill: '#4262FF',
    }),
  );
});
circlebackSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var circleback = {
  category: 'brand',
  colorable: false,
  name: 'circleback',
  svg: circlebackSvg,
};
